import { P, Row, SafeHtml } from 'ia-react-core';
import { Time } from 'omni-package-react-core';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Message } from '../../../../../../interfaces/Message';
import { StyledBoldText } from '../../../../MessageDetailsPage.styles';
import { StyledMailContent, StyledMailText, StyledTextLeft, StyledTextRight } from './Content.styles';

export interface ContentProps {
  message: Message;
}
const Content: FC<ContentProps> = ({ message }) => {
  const { t } = useTranslation('MessageDetailsPage');

  const isReceivedMail = message?.messageSource === 'Inbox';
  const labelDate = isReceivedMail ? `${t('receivedDate')} ` : `${t('sentDate')} `;

  return (
    <StyledMailContent>
      <Row p-t={36}>
        <StyledTextLeft xs={6}>
          <P><StyledBoldText>{labelDate}</StyledBoldText> <Time time={new Date(message?.activationDateUTC)} isDateWithTime /></P>
          {message?.mainRecipient && <P data-testid="recipient"><StyledBoldText>{t('recipient')}</StyledBoldText> {message?.mainRecipient}</P>}
          {message?.anotherRecipient && <P data-testid="otherRecipient"><StyledBoldText>{t('anotherRecipient')}</StyledBoldText> {message?.anotherRecipient}</P>}
        </StyledTextLeft>
        <StyledTextRight xs={6}>
          <P>{t('number')} {message?.id}</P>
        </StyledTextRight>
      </Row>
      <StyledMailText>
        <SafeHtml>{message?.content}</SafeHtml>
      </StyledMailText>
    </StyledMailContent>
  );
};

export default Content;
